<template>
    <Modal :show="true" :prevent-stop-move="true">
        <div class="no-crowd-modal">
            <div class="no-crowd-modal-title" v-html="text.title || ''" />
            <div class="no-crowd-modal-desc" v-html="text.desc || ''" />
            <a class="no-crowd-modal-btn" v-html="text.btn || ''" @click="toActCenter()" />
        </div>
    </Modal>
</template>

<script >
import { computed } from 'vue-demi';
import { useI18n } from '../../lang';
import { toActCenter } from '../../utils/link';
import Modal from '../Modal/index.vue';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const $t = useI18n();
  const text = computed(() => {
    return $t('modal.noCrowd');
  });
  return {
    toActCenter,
    text
  };
};
__sfc_main.components = Object.assign({
  Modal
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less">
.no-crowd-modal {
    width: 5.88rem;
    padding: 3.75rem 0 0.36rem;
    position: relative;
    background: url(../../images/modal/no-crowd.png) no-repeat center 0.64rem ~'/' 2.3rem 2.58rem;
    [cc-platform='futunn'] & {
        background-image: url(../../images/modal/no-crowd-nn.png);
    }
    &::before {
        content: '';
        display: block;
        position: absolute;
        z-index: -2;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        border-radius: 0.3rem;
        background: #ffffff;
    }

    &::after {
        content: '';
        display: block;
        position: absolute;
        z-index: -1;
        top: 3.16rem;
        left: 50%;
        height: 1px;
        width: 4.8rem;
        transform: translateX(-50%);
        background: #eee;
    }

    &-title {
        font-weight: bold;
        font-size: 0.36rem;
        line-height: 1.3;
        text-align: center;
        color: #000000;
    }

    &-desc {
        font-weight: bold;
        font-size: 0.28rem;
        line-height: 1.5;
        text-align: center;
        color: #666;
        margin-top: 0.28rem;
    }

    &-btn {
        background: #ff6900;
        height: 0.88rem;
        width: 4rem;
        border-radius: 0.88rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0.5rem auto 0;
        font-size: 0.32rem;
        color: #fff;
        font-weight: bold;
    }
}
</style>
